// extracted by mini-css-extract-plugin
export default {"coreIdeasContainer":"teacherSci35_coreIdeasContainer__vRNdI","coreIdeaCard":"teacherSci35_coreIdeaCard__LHMxZ"};